import { getScheduleItemFromResult, matchesScheduleId, normalizeScheduleItem, sortSchedules } from '@/lib/automationSchedules/scheduleState.js';
import isDeepEqual from '@/lib/isDeepEqual.js';
import getScopedExistingArray from '@/redux/reducers/pieveReducer/getScopedExistingArray.js';
import resolveCollectionScopeCompanyId from '@/redux/reducers/pieveReducer/resolveCollectionScopeCompanyId.js';

const upsertScheduleItemFromRequestPayload = ({ state, payload } = {}) => {
  const nextScheduleItem = getScheduleItemFromResult(payload?.data || payload);
  const nextScopeCompanyId = resolveCollectionScopeCompanyId({
    payload,
    state,
    ownerKey: 'scheduleItemsScopeCompanyId'
  });

  if (!nextScheduleItem?.id) {
    return state;
  }

  const previousScheduleItems = getScopedExistingArray({
    items: state?.scheduleItems,
    ownerCompanyId: state?.scheduleItemsScopeCompanyId,
    activeCompanyId: nextScopeCompanyId
  });
  const nextScheduleItems = (() => {
    const existingIndex = previousScheduleItems.findIndex((scheduleItem) => matchesScheduleId(scheduleItem, nextScheduleItem?.id));

    if (existingIndex < 0) {
      return sortSchedules([...previousScheduleItems, nextScheduleItem]);
    }

    const existingScheduleItem = previousScheduleItems[existingIndex];
    const mergedScheduleItem =
      normalizeScheduleItem({
        ...existingScheduleItem,
        ...nextScheduleItem,
        id: existingScheduleItem?.id || nextScheduleItem?.id,
        threadId: existingScheduleItem?.threadId || nextScheduleItem?.threadId || null,
        pinned: Boolean(existingScheduleItem?.pinned),
        pinnedAt: existingScheduleItem?.pinnedAt || null,
        sourceType: nextScheduleItem?.sourceType || existingScheduleItem?.sourceType || 'thread'
      }) || nextScheduleItem;
    const nextItems = [...previousScheduleItems];
    nextItems.splice(existingIndex, 1, mergedScheduleItem);
    return sortSchedules(nextItems);
  })();

  if (isDeepEqual(previousScheduleItems, nextScheduleItems) && nextScopeCompanyId === (String(state?.scheduleItemsScopeCompanyId || '').trim() || null)) {
    return state;
  }

  return {
    ...state,
    scheduleItems: nextScheduleItems,
    scheduleItemsScopeCompanyId: nextScopeCompanyId
  };
};

export default upsertScheduleItemFromRequestPayload;
